module.exports = __webpack_public_path__ + "img/multiply.13494743.svg";